//i18n.JS
//Init traductions dans l'application. Utiliser les fichiers json dans languages pour mettre à jour les textes

//Importer module de traduction
import i18n from "i18next"
import HttpApi from "i18next-http-backend"
import { initReactI18next } from "react-i18next"

//Importer fichiers de traduction
import languagesAr from "./languages/ar.json"
import languagesCs from "./languages/cs.json"
import languagesDe from "./languages/de.json"
import languagesEn from "./languages/en.json"
import languagesEs from "./languages/es.json"
import languagesFr from "./languages/fr.json"
import languagesPl from "./languages/pl.json"
import languagesTr from "./languages/tr.json"
import languagesZh from "./languages/zh.json"

// Nouvelles langues
import languagesIt from "./languages/it.json"
import languagesNl from "./languages/nl.json"
import languagesPt from "./languages/pt.json"
import languagesRu from "./languages/ru.json"
import languagesBm from "./languages/bm.json"
import languagesKj from "./languages/kj.json"
import languagesUz from "./languages/uz.json"
import languagesWo from "./languages/wo.json"
import languagesSo from "./languages/so.json"
import languagesYo from "./languages/yo.json"
import languagesHt from "./languages/ht.json"
import languagesFa from "./languages/fa.json"
import languagesFf from "./languages/ff.json"
import languagesHi from "./languages/hi.json"
import languagesLn from "./languages/ln.json"
import languagesMg from "./languages/mg.json"
import languagesUr from "./languages/ur.json"
import languagesPs from "./languages/ps.json"

//Init le module
i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: languagesAr },
      cs: { translation: languagesCs },
      de: { translation: languagesDe },
      en: { translation: languagesEn },
      es: { translation: languagesEs },
      fr: { translation: languagesFr },
      pl: { translation: languagesPl },
      tr: { translation: languagesTr },
      zh: { translation: languagesZh },
      it: { translation: languagesIt },
      nl: { translation: languagesNl },
      pt: { translation: languagesPt },
      ru: { translation: languagesRu },
      bm: { translation: languagesBm },
      kj: { translation: languagesKj },
      uz: { translation: languagesUz },
      wo: { translation: languagesWo },
      so: { translation: languagesSo },
      yo: { translation: languagesYo },
      ht: { translation: languagesHt },
      fa: { translation: languagesFa },
      ff: { translation: languagesFf },
      hi: { translation: languagesHi },
      ln: { translation: languagesLn },
      mg: { translation: languagesMg },
      ur: { translation: languagesUr },
      ps: { translation: languagesPs }
    },
    react: {
      useSuspense: false
    },
    debug: false,
    lng: "en",
    fallbackLng: ["en", "fr"],
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
